/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
  name: "PasswordField",
  props: {
    name: { type: String, required: true },
    id: { type: String, default: undefined },
    value: { type: String, default: "" },
    autocomplete: { type: String, default: undefined },
    required: { type: Boolean, default: false },
    title: { type: String, default: undefined },
    autofocus: { type: Boolean, default: false },
    inputClass: { type: String, default: undefined },
    policy: { type: Object, default: null },
    mustMatch: { type: String, default: undefined },
  },
  data() {
    return {
      visible: false,
      localValue: this.value || "",
    };
  },
  computed: {
    inputClasses() {
      const classes = ["form-control"];
      if (this.inputClass) {
        classes.push(this.inputClass);
      }
      return classes;
    },
    rules() {
      if (!this.policy) return [];
      const r = [];
      const p = this.policy;
      const v = this.localValue;

      r.push({
        label: `At least ${p.min_length} characters`,
        met: v.length >= p.min_length,
      });

      const countMatches = (str, re) => (str.match(re) || []).length;

      if (p.min_uppercase > 0) {
        const n = p.min_uppercase;
        r.push({
          label: `At least ${n} uppercase letter${n > 1 ? "s" : ""}`,
          met: countMatches(v, /[A-Z]/g) >= n,
        });
      }
      if (p.min_lowercase > 0) {
        const n = p.min_lowercase;
        r.push({
          label: `At least ${n} lowercase letter${n > 1 ? "s" : ""}`,
          met: countMatches(v, /[a-z]/g) >= n,
        });
      }
      if (p.min_number > 0) {
        const n = p.min_number;
        r.push({
          label: `At least ${n} number${n > 1 ? "s" : ""}`,
          met: countMatches(v, /\d/g) >= n,
        });
      }
      if (p.min_special > 0) {
        const n = p.min_special;
        r.push({
          label: `At least ${n} special character${n > 1 ? "s" : ""}`,
          met: countMatches(v, /[^A-Za-z0-9]/g) >= n,
        });
      }
      return r;
    },
    allRulesMet() {
      return this.rules.length > 0 && this.rules.every((r) => r.met);
    },
    passwordsMatch() {
      if (this.mustMatch === undefined) return true;
      return this.localValue === this.mustMatch;
    },
  },
  watch: {
    value(newVal) {
      this.localValue = newVal;
    },
    allRulesMet: {
      handler(val) {
        if (this.policy) {
          this.$emit("update:valid", val);
        }
      },
      immediate: true,
    },
  },
  methods: {
    onInput() {
      this.$emit("input", this.localValue);
    },
  },
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "input-group" }, [
      (_vm.visible ? "text" : "password") === "checkbox"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localValue,
                expression: "localValue",
              },
            ],
            class: _vm.inputClasses,
            attrs: {
              id: _vm.id,
              name: _vm.name,
              autocomplete: _vm.autocomplete,
              required: _vm.required || undefined,
              title: _vm.title,
              autofocus: _vm.autofocus || undefined,
              type: "checkbox",
            },
            domProps: {
              checked: Array.isArray(_vm.localValue)
                ? _vm._i(_vm.localValue, null) > -1
                : _vm.localValue,
            },
            on: {
              input: _vm.onInput,
              change: function ($event) {
                var $$a = _vm.localValue,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.localValue = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.localValue = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.localValue = $$c
                }
              },
            },
          })
        : (_vm.visible ? "text" : "password") === "radio"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localValue,
                expression: "localValue",
              },
            ],
            class: _vm.inputClasses,
            attrs: {
              id: _vm.id,
              name: _vm.name,
              autocomplete: _vm.autocomplete,
              required: _vm.required || undefined,
              title: _vm.title,
              autofocus: _vm.autofocus || undefined,
              type: "radio",
            },
            domProps: { checked: _vm._q(_vm.localValue, null) },
            on: {
              input: _vm.onInput,
              change: function ($event) {
                _vm.localValue = null
              },
            },
          })
        : _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localValue,
                expression: "localValue",
              },
            ],
            class: _vm.inputClasses,
            attrs: {
              id: _vm.id,
              name: _vm.name,
              autocomplete: _vm.autocomplete,
              required: _vm.required || undefined,
              title: _vm.title,
              autofocus: _vm.autofocus || undefined,
              type: _vm.visible ? "text" : "password",
            },
            domProps: { value: _vm.localValue },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.localValue = $event.target.value
                },
                _vm.onInput,
              ],
            },
          }),
      _vm._v(" "),
      _c("div", { staticClass: "input-group-append" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-secondary",
            attrs: {
              type: "button",
              "aria-label": _vm.visible ? "Hide password" : "Show password",
            },
            on: {
              click: function ($event) {
                _vm.visible = !_vm.visible
              },
            },
          },
          [
            _c("b-icon", {
              attrs: { icon: _vm.visible ? "eye-slash" : "eye" },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.policy && _vm.localValue.length > 0
      ? _c(
          "ul",
          {
            staticClass: "list-unstyled mt-2 mb-0 small",
            attrs: { "data-testid": "password-checklist" },
          },
          _vm._l(_vm.rules, function (rule, index) {
            return _c(
              "li",
              {
                key: index,
                class: rule.met ? "text-success" : "text-danger",
                attrs: { "data-testid": "password-rule" },
              },
              [
                _c("b-icon", {
                  staticClass: "mr-1",
                  attrs: { icon: rule.met ? "check-circle" : "x-circle" },
                }),
                _vm._v("\n      " + _vm._s(rule.label) + "\n    "),
              ],
              1
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.mustMatch !== undefined && _vm.localValue.length > 0
      ? _c(
          "div",
          {
            staticClass: "mt-1 small",
            class: _vm.passwordsMatch ? "text-success" : "text-danger",
            attrs: { "data-testid": "password-match" },
          },
          [
            _c("b-icon", {
              staticClass: "mr-1",
              attrs: { icon: _vm.passwordsMatch ? "check-circle" : "x-circle" },
            }),
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.passwordsMatch
                    ? "Passwords match"
                    : "Passwords do not match"
                ) +
                "\n  "
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "app/javascript/components/shared/PasswordField.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__